
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/UserDocs/HowItWorks",
      function () {
        return require("private-next-pages/docs/UserDocs/HowItWorks.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/UserDocs/HowItWorks"])
      });
    }
  